import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Box, IconButton, Divider } from 'bonfire-kindling';

import DashboardOverviewContentCard from './DashboardOverviewContentCard';

const CommodityCodes = () => {
  const { t } = useTranslation();

  return (
    <DashboardOverviewContentCard
      title={t('dashboard.overview.commodity_codes.title')}
      count="(0)"
      iconName="code"
      link={
        <IconButton
          component={RouterLink}
          to="/settings/commodity-codes"
          iconName="pencil-alt"
          aria-label={t('dashboard.overview.commodity_codes.edit')}
          variant="outline"
        />
      }
    >
      <Divider />
      <Box>TODO: PV-1341</Box>
    </DashboardOverviewContentCard>
  );
};

export default CommodityCodes;
